import { render, staticRenderFns } from "./Sidepanel.vue?vue&type=template&id=87c2a76e&scoped=true"
import script from "./Sidepanel.vue?vue&type=script&lang=js"
export * from "./Sidepanel.vue?vue&type=script&lang=js"
import style0 from "./Sidepanel.vue?vue&type=style&index=0&id=87c2a76e&prod&lang=scss&scoped=true"
import style1 from "./Sidepanel.vue?vue&type=style&index=1&id=87c2a76e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c2a76e",
  null
  
)

export default component.exports